import React from "react";
import { i18n } from '../../../translate/i18n';
import { Paper, Container, Divider } from "@mui/material";
import TableTitle from "../../../UI/MaterialTableOverrides/TableTitle";
import CondensedReport from "./CondensedReport/CondensedReport";

const Reports = () => {
  return (
    <Container maxWidth="md">
        <Paper>
          <div style={styles.tableTitleContainer}>
            <TableTitle title={i18n.t('reportsPage.report')} hideSearchInput />
          </div>
          <Divider />
          <CondensedReport />
        </Paper>
    </Container>
  )
}

const styles = {
  tableTitleContainer: {
    position: 'relative',
  },
}

export default Reports;
